export default "__VITE_ASSET__DGdUH_OD__"